import type { RouteRecordRaw } from 'vue-router'
import { personalContactsRoutes } from '@/modules/expert/personal-contacts/routes'
import { memberRoutes } from '@/modules/expert/member/routes'
import { eventsRoutes } from '@/modules/expert/events/routes'
import { customFieldsRoutes } from '@/modules/expert/custom-fields/routes'
import { corporativeContactsRoutes } from '@/modules/expert/corporative-contacts/routes'
import { notificationsRoutes } from '../notifications/routes'

export const expertRoutes: RouteRecordRaw[] = [
  {
    path: '/expert',
    component: () => import('@/layouts/Main.vue'),
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/views/Panel/PanelIndex.vue'),
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import('@/views/Profile.vue'),
      },
      {
        path: 'create',
        name: 'create-corporative-account',
        component: () => import('@/views/Create.vue'),
      },
      {
        path: ':id',
        name: 'home-corporative-account',
        component: () => import('@/views/Panel/PanelIndex.vue'),
      },
      {
        path: ':id/detail',
        name: 'detail-corporative-account',
        component: () => import('@/views/Detail.vue'),
      },
      {
        path: ':id/edit',
        name: 'edit-corporative-account',
        component: () => import('@/views/Edit.vue'),
        meta: { isAdmin: true },
      },
      {
        path: 'onboarding',
        name: 'onboarding',
        component: () => import('@/views/Onboarding.vue'),
      },
      {
        path: 'building',
        name: 'building',
        component: () => import('@/views/Building.vue'),
      },

      // módulos (apenas children relativos)
      ...eventsRoutes,
      ...personalContactsRoutes,
      ...corporativeContactsRoutes,
      ...memberRoutes,
      ...customFieldsRoutes,
      ...notificationsRoutes,
    ],
  },
]
